import { currencySchema } from '@btsis/core';
import { z } from 'zod';

export const minorAmountSchema = z
  .string()
  .regex(/^\d{1,18}$/, 'must be a non-negative integer in minor units');

export const moneySchema = z.object({
  amountMinor: z.string().regex(/^-?\d+$/, 'must be an integer in minor units'),
  currency: currencySchema,
});

export type MoneyDto = z.infer<typeof moneySchema>;
